// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Account from "./account.js"
import ClassStep from "./class-step.js"
import Contact from "./contact.js"
import Country from "./country.js"
import SchoolClass from "./school-class.js"
import Subscription from "./subscription.js"

const modelClassData = {
  "attributes": {
    "account_id": {
      "column": {
        "default": null,
        "name": "account_id",
        "null": true,
        "type": null
      },
      "name": "account_id",
      "selected_by_default": null,
      "translated": null
    },
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": true,
        "type": null
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "email": {
      "column": null,
      "name": "email",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "principal_name": {
      "column": {
        "default": null,
        "name": "principal_name",
        "null": true,
        "type": "string"
      },
      "name": "principal_name",
      "selected_by_default": null,
      "translated": null
    },
    "school_classes_count": {
      "column": {
        "default": "0",
        "name": "school_classes_count",
        "null": false,
        "type": "integer"
      },
      "name": "school_classes_count",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "institution_number": {
      "column": {
        "default": null,
        "name": "institution_number",
        "null": true,
        "type": "integer"
      },
      "name": "institution_number",
      "selected_by_default": null,
      "translated": null
    },
    "has_pro_subscription": {
      "column": null,
      "name": "has_pro_subscription",
      "selected_by_default": false,
      "translated": null
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": null
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": null
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": null
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": null
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "School",
  "collectionKey": "schools",
  "collectionName": "schools",
  "i18nKey": "school",
  "camelizedLower": "school",
  "name": "School",
  "nameDasherized": "school",
  "pluralName": "schools",
  "ransackable_associations": [
    {
      "className": "Account",
      "collectionName": "accounts",
      "foreignKey": "account_id",
      "name": "account",
      "macro": "belongs_to",
      "resource_name": "Account",
      "through": null
    },
    {
      "className": "AccountSchool",
      "collectionName": "account_schools",
      "foreignKey": "school_id",
      "name": "account_schools",
      "macro": "has_many",
      "resource_name": "AccountSchool",
      "through": null
    },
    {
      "className": "Account",
      "collectionName": "accounts",
      "foreignKey": "account_id",
      "name": "accounts",
      "macro": "has_many",
      "resource_name": "Account",
      "through": "account_schools"
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "contact_id",
      "name": "active_subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": "contact"
    },
    {
      "className": "School::Audit",
      "collectionName": "school_audits",
      "foreignKey": "school_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SchoolAudit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "current_school_id",
      "name": "audits_as_school",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_steps",
      "macro": "has_many",
      "resource_name": "ClassStep",
      "through": "school_classes"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Country",
      "collectionName": "countries",
      "foreignKey": "country_id",
      "name": "country",
      "macro": "has_one",
      "resource_name": "Country",
      "through": "contact"
    },
    {
      "className": "CountryState",
      "collectionName": "country_states",
      "foreignKey": "country_state_id",
      "name": "country_state",
      "macro": "has_one",
      "resource_name": "CountryState",
      "through": "contact"
    },
    {
      "className": "School::Audit",
      "collectionName": "school_audits",
      "foreignKey": "school_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SchoolAudit",
      "through": null
    },
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "school_class_id",
      "name": "school_class_check_ins",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckIn",
      "through": "school_classes"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "school_class_child_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": "contact"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "school_class_contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "school_class_child_relationships"
    },
    {
      "className": "SchoolClassCourse",
      "collectionName": "school_class_courses",
      "foreignKey": "school_class_id",
      "name": "school_class_courses",
      "macro": "has_many",
      "resource_name": "SchoolClassCourse",
      "through": "school_classes"
    },
    {
      "className": "SchoolClassInvitation",
      "collectionName": "school_class_invitations",
      "foreignKey": "resource_id",
      "name": "school_class_invitations",
      "macro": "has_many",
      "resource_name": "SchoolClassInvitation",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "contact_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": "school_class_contacts"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "school_leader_contact_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": "contact"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "school_leader_contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "school_leader_contact_relationships"
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "contact_id",
      "name": "school_leaders",
      "macro": "has_many",
      "resource_name": "User",
      "through": "school_leader_contacts"
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "contact_id",
      "name": "subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": "contact"
    },
    {
      "className": "ContactRelationship",
      "collectionName": "contact_relationships",
      "foreignKey": "parent_id",
      "name": "user_contact_relationships",
      "macro": "has_many",
      "resource_name": "ContactRelationship",
      "through": "contact"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "user_contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "user_contact_relationships"
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "contact_id",
      "name": "users",
      "macro": "has_many",
      "resource_name": "User",
      "through": "user_contacts"
    }
  ],
  "ransackable_attributes": [
    {
      "name": "account_id",
      "column": {
        "default": null,
        "name": "account_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "institution_number",
      "column": {
        "default": null,
        "name": "institution_number",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "norwegian_institution_number",
      "column": {
        "default": null,
        "name": "norwegian_institution_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "principal_name",
      "column": {
        "default": null,
        "name": "principal_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "school_classes_count",
      "column": {
        "default": "0",
        "name": "school_classes_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "subscriptions_count",
      "column": {
        "default": "0",
        "name": "subscriptions_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "swedish_institution_number",
      "column": {
        "default": null,
        "name": "swedish_institution_number",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "with_active_subscription"
    },
    {
      "name": "with_contact_id"
    },
    {
      "name": "with_data_insights_for"
    },
    {
      "name": "with_school_role_contact_id"
    }
  ],
  "relationships": [
    {
      "className": "Account",
      "collectionName": "accounts",
      "foreignKey": "account_id",
      "name": "account",
      "macro": "belongs_to",
      "resource_name": "Account",
      "through": null
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "contact_id",
      "name": "active_subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": "contact"
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_steps",
      "macro": "has_many",
      "resource_name": "ClassStep",
      "through": "school_classes"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Country",
      "collectionName": "countries",
      "foreignKey": "country_id",
      "name": "country",
      "macro": "has_one",
      "resource_name": "Country",
      "through": "contact"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "contact_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": "school_class_contacts"
    }
  ],
  "paramKey": "school",
  "primaryKey": "id"
}

/** Frontend model for School. */
export default class School extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any | null} */
  accountId() {
    return this.readAttributeUnderscore("account_id")
  }

  /** @returns {boolean} */
  hasAccountId() {
    const value = this.accountId()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  email() {
    return this.readAttributeUnderscore("email")
  }

  /** @returns {boolean} */
  hasEmail() {
    const value = this.email()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  principalName() {
    return this.readAttributeUnderscore("principal_name")
  }

  /** @returns {boolean} */
  hasPrincipalName() {
    const value = this.principalName()

    return this._isPresent(value)
  }

  /** @returns {number} */
  schoolClassesCount() {
    return this.readAttributeUnderscore("school_classes_count")
  }

  /** @returns {boolean} */
  hasSchoolClassesCount() {
    const value = this.schoolClassesCount()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  institutionNumber() {
    return this.readAttributeUnderscore("institution_number")
  }

  /** @returns {boolean} */
  hasInstitutionNumber() {
    const value = this.institutionNumber()

    return this._isPresent(value)
  }

  /** @returns {any} */
  hasProSubscription() {
    return this.readAttributeUnderscore("has_pro_subscription")
  }

  /** @returns {boolean} */
  hasHasProSubscription() {
    const value = this.hasProSubscription()

    return this._isPresent(value)
  }

  /** @returns {any} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static merge(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "merge",
        collectionName: "schools",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("./account.js").default | null} */
  account() {
    return this._readBelongsToReflection({modelClass: Account, reflectionName: "account"})
  }

  /** @returns {Promise<import("./account.js").default | null>} */
  loadAccount() {
    if (!("accountId" in this)) throw new Error("Foreign key method wasn't defined: accountId")

    const id = this.accountId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "account",
        model: this,
        modelClass: Account
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./account.js").default | null>} */
  ensureAccountLoaded() {
    return this.ensureAssociationLoaded("account")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./subscription.js").default>} */
  activeSubscriptions() {
    return new Collection(
      {
        reflectionName: "active_subscriptions",
        model: this,
        modelClass: Subscription
      },
      {
        params: {
          through: {
            model: "School",
            id: this.primaryKey(),
            reflection: "active_subscriptions"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./subscription.js").default>>} */
  loadActiveSubscriptions() {
    return this._loadHasManyReflection(
      {
        reflectionName: "active_subscriptions",
        model: this,
        modelClass: Subscription
      },
      {
        params: {
          through: {
            model: "School",
            id: this.primaryKey(),
            reflection: "active_subscriptions"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./subscription.js").default>>} */
  ensureActiveSubscriptionsLoaded() {
    return this.ensureAssociationLoaded("active_subscriptions")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./class-step.js").default>} */
  classSteps() {
    return new Collection(
      {
        reflectionName: "class_steps",
        model: this,
        modelClass: ClassStep
      },
      {
        params: {
          through: {
            model: "School",
            id: this.primaryKey(),
            reflection: "class_steps"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./class-step.js").default>>} */
  loadClassSteps() {
    return this._loadHasManyReflection(
      {
        reflectionName: "class_steps",
        model: this,
        modelClass: ClassStep
      },
      {
        params: {
          through: {
            model: "School",
            id: this.primaryKey(),
            reflection: "class_steps"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./class-step.js").default>>} */
  ensureClassStepsLoaded() {
    return this.ensureAssociationLoaded("class_steps")
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./country.js").default | null} */
  country() {
    return this._readHasOneReflection({modelClass: Country, reflectionName: "country"})
  }

  /** @returns {Promise<import("./country.js").default | null>} */
  loadCountry() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "country",
        model: this,
        modelClass: Country
      },
      {
        params: {
          through: {
            model: "School",
            id,
            reflection: "country"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./country.js").default | null>} */
  ensureCountryLoaded() {
    return this.ensureAssociationLoaded("country")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class.js").default>} */
  schoolClasses() {
    return new Collection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {
        params: {
          through: {
            model: "School",
            id: this.primaryKey(),
            reflection: "school_classes"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./school-class.js").default>>} */
  loadSchoolClasses() {
    return this._loadHasManyReflection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {
        params: {
          through: {
            model: "School",
            id: this.primaryKey(),
            reflection: "school_classes"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./school-class.js").default>>} */
  ensureSchoolClassesLoaded() {
    return this.ensureAssociationLoaded("school_classes")
  }
}
